import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { MessageService } from '../service-ui/message.service';
import { HttpClient} from '@angular/common/http';
import {catchError, map, tap} from 'rxjs/operators';
import { StartupService } from '../service-ui/startup.service';
import {environment} from "../../environments/environment";
import {NotificationsService} from "./notifications.service";
import {PrintNodeOrder} from "../../model/PrintNodeOrder";
import {AbstractLiveDataService} from "./abstract-live-data.service";
import {ObjectAttachRequest} from "./data-service";

@Injectable()
export class PrintNodeOrderService extends AbstractLiveDataService<PrintNodeOrder> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    notificationsService.setPrintNodeOrderService(this);
    notificationsService.startNotification();
  }

  makeObjectInstance(args: any): PrintNodeOrder {
    return new PrintNodeOrder(args);
  }

  getLoggingObjectTypeName (): string {
    return "PrintNodeOrder";
  }

  supportsParallel(): boolean {
    return true;
  }

  supportsLimitedParallel(): boolean {
    return true;
  }

  protected objectQualifiedPrimaryKeyId(): string {
    return 'printNodeOrder.ID';
  }

  getURLEndPoint (): string {
    return "printnodeorder";
  }

  updatePrintNodeOrderItems(changeItems: any) {
    const url = `${environment.apiBaseURL}printnodeorder/items/${changeItems.printNodeOrderId}`;
    this.messageService.add(`PrintNodeOrderService: updated printNodeOrder id=${changeItems.printNodeOrderId}`);

    return this.http.put(url, changeItems, this.startupService.getHttpOptions()).
    pipe(tap(_ => this.log(`updated printNodeOrder id=${changeItems.printNodeOrderId}`)), catchError(this.handleErrorX<any>('updatePrintNodeOrderWithItems')));
  }

  changeAddress (printNodeOrder: PrintNodeOrder) {
    const url = `${environment.apiBaseURL}printnodeorder/changeaddress/${printNodeOrder.ID}`;
    this.messageService.add(`PrintNodeOrderService: updated printNodeOrder id=${printNodeOrder.ID}`);

    // The recipient fields (title / firstname / lastname / company) travel with
    // the address so a mis-keyed name or a missing company can be corrected in
    // the facility packages batch flow without re-placing the order.
    // address3/address4 are included because `useThisAddress()` copies them off
    // a validated suggestion; without them here that edit was silently lost.
    // Server rule: an ABSENT field leaves the stored value untouched, an empty
    // string is persisted as empty — so all fields are sent unconditionally.
    // See docs/contracts/shared/ChangeAddress.md.
    const printNodeOrderAddress = {};
    printNodeOrderAddress['ID'] = printNodeOrder.ID;
    printNodeOrderAddress['orderDeliverToId'] = printNodeOrder.orderdeliverto_ID;
    printNodeOrderAddress['title'] = printNodeOrder.title;
    printNodeOrderAddress['firstname'] = printNodeOrder.firstname;
    printNodeOrderAddress['lastname'] = printNodeOrder.lastname;
    printNodeOrderAddress['company'] = printNodeOrder.company;
    printNodeOrderAddress['address1'] = printNodeOrder.address1;
    printNodeOrderAddress['address2'] = printNodeOrder.address2;
    printNodeOrderAddress['address3'] = printNodeOrder.address3;
    printNodeOrderAddress['address4'] = printNodeOrder.address4;
    printNodeOrderAddress['city'] = printNodeOrder.city;
    printNodeOrderAddress['state'] = printNodeOrder.state;
    printNodeOrderAddress['country'] = printNodeOrder.country;
    printNodeOrderAddress['postalcode'] = printNodeOrder.postalcode;

    return this.http.put(url, printNodeOrderAddress, this.startupService.getHttpOptions()).
    pipe(tap(_ => this.log(`updated printNodeOrder id=${printNodeOrder.ID}`)), catchError(this.handleErrorX<any>('updated address in PrintNodeOrder')));
  }

  split (splitPrintNodeOrderRequest: any) {
    const url = `${environment.apiBaseURL}printnodeorder/split`;
    // NOTE: intentionally bypass handleErrorX here so the
    // HttpErrorResponse (with its `status` + structured `error.warnings[]`
    // payload) reaches the component's error handler. The Split dialog
    // distinguishes 409 (conflict with conflict-reasons in
    // `warnings[]`) from 500 (generic error) and displays each
    // differently. See docs/contracts/shared/SplitPrintNodeOrder.md.
    return this.http.put(url, splitPrintNodeOrderRequest, this.startupService.getHttpOptions()).
    pipe(tap(_ => this.log(`Split printNodeOrder ${JSON.stringify(splitPrintNodeOrderRequest)}`)));
  }
  changePackages(packageChangeRequest: any) {
    const url = `${environment.apiBaseURL}printnodeorder/changepackages`;
    // NOTE: intentionally bypass handleErrorX here so the
    // HttpErrorResponse (with its `status` + structured
    // `error.warnings[]` payload) reaches the component's error
    // handler. The Change Packages dialog distinguishes HTTP 409
    // (protected-package guard rejection — structured warnings of
    // the form `{ packageId, requiredOverrideLevel, message }`)
    // from 500 (generic error) and displays each differently. See
    // docs/contracts/shared/ChangePackages.md.
    return this.http.put(url, packageChangeRequest, this.startupService.getHttpOptions()).
    pipe(tap(_ => this.log(`Change Packages in PrintNodeOrder ${JSON.stringify(packageChangeRequest)}`)));
  }

  // changeFacility (printNodeOrder: PrintNodeOrder) {
  //   const url = `${environment.apiBaseURL}printnodeorder/changefacility/${printNodeOrder.ID}/${printNodeOrder.printnode_ID}`;
  //   this.messageService.add(`PrintNodeOrderService: change facility printNodeOrder id=${printNodeOrder.ID} new facility ${printNodeOrder.printnode_ID}`);
  //   return this.http.put(url, {}, this.startupService.getHttpOptions()).
  //   pipe(tap(_ => this.log(`updated printNodeOrder id=${printNodeOrder.ID}`)), catchError(this.handleErrorX<any>('updated address in PrintNodeOrder')));
  // }
  //
  // /** PUT: move PrintNodeOrderItem to a specific ManufacturingTaskBucket */
  // movePrintNodeOrderToManufacturingTaskBucket (printNodeOrderId: number, manufacturingTaskBucketId: number): Observable<ManufacturingTaskBucket> {
  //   const url = `${environment.apiBaseURL}${this.getURLEndPoint()}/moveprintnodeordertomanufacturingtaskbucket/${printNodeOrderId}/${manufacturingTaskBucketId}`;
  //   this.messageService.add(`PrintNodeOrderService: movePrintNodeOrderToManufacturingTaskBucket manufacturingTaskBucketId=${manufacturingTaskBucketId}  printNodeOrderId=${printNodeOrderId}`);
  //   return this.http.put(url, {}, this.startupService.getHttpOptions())
  //     .pipe(
  //       map(manufacturingTaskBucket => {
  //         const m = new ManufacturingTaskBucket(manufacturingTaskBucket);
  //         return m;
  //       }),
  //       catchError(this.handleErrorX<any>('movePrintNodeOrder'))
  //     );
  // }
  //
  // /** PUT: move PrintNodeOrderItem to a specific ManufacturingTaskBucketPeriod */
  // movePrintNodeOrderToManufacturingTaskBucketPeriod (printNodeOrderId: number, manufacturingTaskBucketPeriodId: number): Observable<ManufacturingTaskBucketPeriod> {
  //   const url = `${environment.apiBaseURL}${this.getURLEndPoint()}/moveprintnodeordertomanufacturingtaskbucketperiod/${printNodeOrderId}/${manufacturingTaskBucketPeriodId}`;
  //   this.messageService.add(`PrintNodeOrderService: movePrintNodeOrderToManufacturingTaskBucketPeriod manufacturingTaskBucketPeriodId=${manufacturingTaskBucketPeriodId}  printNodeOrderId=${printNodeOrderId}`);
  //   return this.http.put(url, {}, this.startupService.getHttpOptions())
  //     .pipe(
  //       map(manufacturingTaskBucketPeriod => {
  //         const m = new ManufacturingTaskBucketPeriod(manufacturingTaskBucketPeriod);
  //         return m;
  //       }),
  //       catchError(this.handleErrorX<any>('movePrintNodeOrder'))
  //     );
  // }

  /**
   * Catch error helper for per-operation PUT/POST calls (e.g.
   * `split`, `changePackages`, `updateAddress`). The single string
   * argument is a human-readable operation label used only for
   * logging.
   *
   * NOTE: earlier versions of this method also accepted a `role`
   * argument and did `this.loadingState[role] = 'INITIAL'`. That was
   * wrong on two counts:
   *   1. `loadingState` on `AbstractDataService` is a plain string
   *      (`'INITIAL' | 'LOADING' | 'LOADED' | 'ERROR'`), not an
   *      indexed object — so indexed assignment threw
   *      "Cannot create property 'PackageChange PrintNodeOrder' on
   *       string 'LOADED'" once the service had finished its initial
   *      load.
   *   2. A failed one-shot operation should not silently reset the
   *      whole-collection loading state.
   *
   * The signature now reflects the actual call-site contract and
   * leaves `loadingState` alone.
   */
  private handleErrorX<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error, operation); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error && error.message ? error.message : error}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getLinkData(): any[] {
    return [
      { action: 'AddUpdateArray', serviceName: 'printNodeOrderItemService', arrayProperty: 'printNodeOrderItems'},
      { action: 'Link', objectIdPropertyName: 'manufacturingTaskBucketPeriod_id', serviceName: 'manufacturingTaskBucketPeriodService', arrayProperty: 'manufacturingSets', objectProperty: 'manufacturingTaskBucketPeriod'},
      { action: 'Link', objectIdPropertyName: 'org_ID', serviceName: 'organizationService', arrayProperty: 'printNodeOrders', objectProperty: 'organization'},
      { action: 'AddUpdateArray', serviceName: 'manufacturingTaskService', arrayProperty: 'manufacturingTasks'},
    ];
  }

  // linkObject(newObject: PrintNodeOrder, rawObject: PrintNodeOrder) {
  //   if ( rawObject.organization ) {
  //     this.notificationsService.addUpdateLocalItem('organizationService', rawObject.organization);
  //   }
  //   if ( newObject.org_ID ) {
  //     this.notificationsService.addObjectAttachRequest('organizationService', new ObjectAttachRequest(newObject.org_ID, 'printNodeOrders', 'organization', newObject));
  //   }
  //   if ( rawObject.printNodeOrderItems ) {
  //     for ( const printNodeOrderItem of rawObject.printNodeOrderItems ) {
  //       this.notificationsService.addUpdateLocalItem('printNodeOrderItemService', printNodeOrderItem);
  //     }
  //   }
  // }
}
